module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"header":{"idAndVersion":"ID and Version"}}}')
  delete Component.options._Ctor
}
